import Constrants from "../constrants/constrant";

// Generic GET helper
const fetchData = async (endpoint, options = {}) => {
  try {
    const response = await Constrants.get(endpoint);
    const { isArray = false, nestedData = false } = options;

    let data = nestedData ? response.data.data : response.data;

    if (isArray && !Array.isArray(data)) return [];
    return data || [];
  } catch (error) {
    console.error(`Error fetching from ${endpoint}:`, error);
    throw error;
  }
};

// Game Section APIs
export const fetchGamesCategories = () => fetchData("/games/home-categories", { nestedData: true });
export const fetchRecommendedGamesHome = () => fetchData("/games/home-recommended", { isArray: true });
export const fetchTopGamesHome = () => fetchData("/games/home-top-apps", { isArray: true });
export const fetchLatestGamesHome = () => fetchData("/games/home-latest", { isArray: true });
export const fetchHomeGameCollections = () => fetchData("/games/collections", { isArray: true });
export const fetchHomeAppCollections = () => fetchData("/games/collections", { isArray: true });
